import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImageviewComponent } from '../components/imageview/imageview.component';

@NgModule({
  declarations: [ImageviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ImageviewComponent],
  imports: [
    CommonModule,
    FormsModule,
  ]
})
export class ImageviewModule { }
